



































































import Vue from "vue";

interface SideNavListItem {
  id: string;
  name: string;
  icon: string;
  to: object | string;
}

export default Vue.extend({
  computed: {
    exampleCollectionsMenuItems(): SideNavListItem[] {
      const pages = this.$docLoader.pages;
      return pages.map(page => {
        return {
          id: page.slug,
          name: page.title,
          icon: page.icon,
          to: {
            name: "example",
            params: { slug: page.slug }
          }
        };
      });
    },
    staticMenuItems(): SideNavListItem[] {
      return [
        { id: "start", name: "Start", icon: "home", to: "/start" },
        {
          id: "new-component",
          name: "New Component Guide",
          icon: "write-new",
          to: "/guide/new-component"
        }
      ];
    }
  },
  data() {
    return {
      activeNavItemId: "./Action Bar/index.ts"
    };
  }
});
